// Single source of truth for the HTML parse seam used by every cf-id site.
// Content-hash cf-ids are only stable if every parse site produces an identical
// tree — migration-write (rewriteFrameHtml/buildFrameIdMap) and render-mint
// (injectCfNodeIds) must agree element-for-element, so they MUST parse the same
// way. Keep this the only implementation. jsdom provides <template> in tests.

/** Parse an HTML string into a detached `<div>` host (via `<template>`). */
export function parseFragment(html: string): HTMLElement {
  const tmpl = document.createElement('template');
  tmpl.innerHTML = html;
  const host = document.createElement('div');
  host.appendChild(tmpl.content);
  return host;
}

/** Serialize a parsed host back to HTML. */
export function serializeFragment(root: HTMLElement): string {
  return root.innerHTML;
}
